import React from 'react';
import PropTypes from 'prop-types';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import {
  useModalContextSubmissionSuccessful,
  useRefreshModalCollectionCleared,
} from 'Hooks/useRefreshEvent';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { CashFlowSectionPicker } from 'Views/Page/Content/Templates/CashFlowMDCPageTemplate/CashFlowSectionPicker';
import { CompleteActionItemBanner } from 'Components/ComponentLibrary/Organisms/CompleteActionItemBanner';
import { CashFlowPageActions } from './CashFlowPageActions';

export const CashFlowPageTemplate = ({ resource }) => {
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  useBoneBackgroundColor();

  useModalContextSubmissionSuccessful((evt, clearModalCollectionDependency) => {
    switch (evt.detail.response.meta().type()) {
      case 'householdExpenseCategoryPX':
      case 'IncomeDetail':
        clearModalCollectionDependency();

      /* no default */
    }
  }, [clearModalCollection]);

  useRefreshModalCollectionCleared(() => {
    refreshPageContentCollection();
  });

  return (
    <>
      <CompleteActionItemBanner resource={resource} />
      <FDContentContainer maxWidth={'lg'}>
        <PageHeader
          title={resource.attr('name')}
          actions={<CashFlowPageActions
            cashFlowResource={resource}
            onAddJob={(rel) => loadModalCollectionByLink(rel.link('related').url())}
            onAddExpense={(rel) => loadModalCollectionByLink(rel.link('related').url())}
          />}
        />
        <FDStack wrap spacing={2} justifyContent={'center'} alignItems={'flex-start'}>
          {resource.attr('sections').resources().list().map((sectionResource) => (
            <CashFlowSectionPicker
              key={sectionResource.id()}
              sectionResource={sectionResource}
              onEditItemClick={(rel) => loadModalCollectionByLink(rel.link('related').url())}
            />
          ))}
        </FDStack>
      </FDContentContainer>
    </>
  );
};

CashFlowPageTemplate.defaultProps = {
};

CashFlowPageTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};
